import { useQuery } from '@tanstack/react-query';
import { fetcher } from 'src/api/fetcher';
import { API_RESOURCES } from 'src/utils/constants';
import { getUuid } from 'src/utils/url';

export const usePrinter = (printerUri, options = {}) => {
  const { enabled = true, ...queryOptions } = options;
  return useQuery({
    queryKey: ['printer', 'printer-by-uri', printerUri],
    queryFn: () => fetcher(`${API_RESOURCES.PRINTER}/${getUuid(printerUri)}`),
    enabled: Boolean(enabled && printerUri),
    ...queryOptions,
  });
};

export const usePrinterType = (printerTypeUri, options = {}) => {
  const { enabled = true, ...queryOptions } = options;
  return useQuery({
    queryKey: ['printer-type', 'printer-type-by-uri', printerTypeUri],
    queryFn: () => fetcher(`${API_RESOURCES.PRINTER_TYPE}/${getUuid(printerTypeUri)}`),
    enabled: Boolean(enabled && printerTypeUri),
    ...queryOptions,
  });
};
